export default "__VITE_ASSET__cdf8ec1a__"